<template>
  <h4>Frequently Asked Questions</h4>
  <p><br /><strong class="faqstrong">Policy Questions</strong></p>
  <div class="question">
    <input id="q1" type="checkbox" name="faq" /><label for="q1">
      Who is the administrator / underwriter of this Renters Insurance
      policy?</label
    >
    <div class="answer">
      <p style="margin-bottom: 0px">
        Property damage liability, personal liability, and personal property
        coverage is provided through
      </p>
      <div class="tooltip-hotspot">
        <span>Assurant.</span>
        <div class="tooltip-content">
          In all states, unless otherwise noted, Renters Insurance is
          underwritten by American Bankers Insurance Company of Florida with its
          its home office in Miami, Florida. In Minnesota, the underwriter is
          American Security Insurance company. In Georgia, Residents Liability
          is underwritten by Voyager Indemnity Insurance Company. In Utah,
          coverage is provided under policy form AJ8850PC-0307 or
          AJ9281CKK-0609. The trade name Assurant is used to associate their
          products and services, and to connect with the brand of their parent
          company, Assurant, Inc.
        </div>
      </div>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q2" type="checkbox" name="faq" /><label for="q2">
      Who is the administrator / underwriter of the accidental damage personal
      property coverage add-on?</label
    >
    <div class="answer">
      <p>
        Accidental damage personal property coverage is provided by
        <a href="https://nssi.com/" target="_blank">NSSI</a>. This policy is
        underwritten by
        <a href="https://www.hanover.com/">The Hanover Insurance Group.</a>
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q3" type="checkbox" name="faq" /><label for="q3">
      What does coverage amount mean?</label
    >
    <div class="answer">
      <p>
        The coverage amount is the maximum dollar amount that can be paid out on
        on your approved claim. It may also be referred to as your policy limit
        limit or limit of coverage.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q4" type="checkbox" name="faq" /><label for="q4">
      What is a deductible?</label
    >
    <div class="answer">
      <p>
        A deductible is an amount that must be paid by the policyholder in order
        order for the claim to be paid out.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q12" type="checkbox" name="faq" />
    <label for="q12"> Will you cover my things outside of my housing?</label>
    <div class="answer">
      <p>
        Yes. Your renters insurance personal property coverage covers your
        things no matter where they are, whether it’s your garage, storage unit
        unit or grandma’s basement.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q15" type="checkbox" name="faq" /><label for="q15"
      >How do I update my address?</label
    >
    <div class="answer">
      <p>
        Visit
        <a href="https://MyAssurantPolicy.com" target="_blank"
          >MyAssurantPolicy.com</a
        >
        and
        <a href="https://www.nssi.com/customer/account/login/" target="_blank"
          >NSSI.com</a
        >
        to update the address on your policies.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q19" type="checkbox" name="faq" /><label for="q19">
      Can I buy coverage if my lease hasn't started yet?</label
    >
    <div class="answer">
      <p>Yes!</p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q20" type="checkbox" name="faq" /><label for="q20">
      Can I make changes to my policy after I buy?</label
    >
    <div class="answer">
      <p>
        Visit
        <a href="https://MyAssurantPolicy.com" target="_blank">
          MyAssurantPolicy.com
        </a>
        to make changes on your renters insurance policy, such as updating your
        your address, adding a roommate or changing payment information. You
        will need to go to
        <a href="https://www.nssi.com/customer/account/login/" target="_blank">
          NSSI.com
        </a>
        to manage your accidental damage personal property coverage add-on.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q22" type="checkbox" name="faq" />
    <label for="q22"> Where can I get my policy documents? </label>
    <div class="answer">
      <p>
        We will email your policy documents within 2 business days of purchase.
        You can obtain a copy of your policy, declaration page, or proof of
        coverage at
        <a href="https://MyAssurantPolicy.com/" target="_blank">
          MyAssurantPolicy.com
        </a>
        for your Renter Insurance. <br /><br />
        You can obtain your proof of coverage or declaration page for your
        accidental damage personal property add-on at
        <a href="https://www.nssi.com/customer/account/login/" target="_blank">
          NSSI.com </a
        >.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q24" type="checkbox" name="faq" />
    <label for="q24">
      Can I buy a Renters Insurance policy if I or my parents own my home?
    </label>
    <div class="answer">
      <p>No, you won’t be eligible for Renters Insurance.</p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q35" type="checkbox" name="faq" /><label for="q35">
      Do I need to file a police report?</label
    >
    <div class="answer">
      <p>
        Notify the police in case of a loss by theft or vandalism or malicious
        mischief.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q35a" type="checkbox" name="faq" />
    <label for="q35a"> Is theft from a car covered? </label>
    <div class="answer">
      <p>
        Yes, with personal property coverage you're covered if your things are
        stolen from a car with visible signs of forced entry.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <br /><br />
  <p>
    <strong strong="" class="faqstrong">
      Payment Billings and Cancellation Information
    </strong>
  </p>
  <div class="question">
    <input id="q27" type="checkbox" name="faq" />
    <label for="q27"> Can I cancel my coverage? </label>
    <div class="answer">
      <p>
        You can cancel at any time. To cancel your Renters Insurance, go to
        <a href="https://MyAssurantPolicy.com/" target="_blank">
          MyAssurantPolicy.com
        </a>
        . To cancel your NSSI accidental damage add-on, contact NSSI at
        <a href="tel:8002566774">1-800-256-6774</a>.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q30" type="checkbox" name="faq" />
    <label for="q30">
      How can I change my billing or credit card information?
    </label>
    <div class="answer">
      <p>
        For your Renters Insurance policy, you can update payment and billing
        information at
        <a href="https://MyAssurantPolicy.com/" target="_blank">
          MyAssurantPolicy.com
        </a>
        . Contact NSSI at
        <a href="tel:8002566774">1-800-256-6774</a> Mon.-Fri. 8:00am-5:00pm CT
        to update your billing or credit card information for your accidental
        damage policy.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
  <div class="question">
    <input id="q33" type="checkbox" name="faq" />
    <label for="q33">
      Can I cancel one policy without canceling the other?
    </label>
    <div class="answer">
      <p>
        Yes. Since Renters Insurance and accidental damage personal property
        coverage are separate policies, you can cancel one and keep the other.
      </p>
    </div>
  </div>
  <!------------------------ spacer ---------------------------->
</template>
